import { Suspense, lazy } from 'react'
import { Switch, Redirect } from 'react-router-dom'
import { Mode } from '@ocean/types/dist/appearance'
import { common } from '@ocean/ui'
import { PrivateRoute } from 'routing/components'
import { EnvironmentUtils } from 'utils'
import simulatorTrainingRoutes from 'modules/simulatorTrainings/common/routing/routes'
import routes from './routes'

const { RouteChangeProgress } = common

export { routes }

export const Schedules = lazy(
  () =>
    import(
      /* webpackChunkName: "SimulatorTrainingInstructorILSchedules" */ 'modules/simulatorTrainings/instructor/instructorLed/Schedules/pages/Schedules'
    )
)

export const ScheduleEditor = lazy(
  () =>
    import(
      /* webpackChunkName: "SimulatorTrainingInstructorILScheduleEditor" */ 'modules/simulatorTrainings/instructor/instructorLed/Schedules/pages/ScheduleEditor'
    )
)

export const ScheduleCreator = lazy(
  () =>
    import(
      /* webpackChunkName: "SimulatorTrainingInstructorILScheduleCreator" */ 'modules/simulatorTrainings/instructor/instructorLed/Schedules/pages/ScheduleCreator'
    )
)

const SchedulesRouting = () => {
  const { instructorLedSchedulesAdd, instructorLedSchedulesAvailable, instructorLedSchedulesEdit } =
    EnvironmentUtils.getPermissions('simulatorTraining')

  return (
    <Suspense fallback={<RouteChangeProgress mode={Mode.Light} />}>
      <Switch>
        <PrivateRoute
          exact
          path={`${routes.list}/:trainingId`}
          component={Schedules}
          disabled={!instructorLedSchedulesAvailable}
        />
        <PrivateRoute
          exact
          path={`${routes.edit}/:scheduleId`}
          component={ScheduleEditor}
          disabled={!instructorLedSchedulesEdit}
        />
        <PrivateRoute
          exact
          path={`${routes.create}/:trainingId`}
          component={ScheduleCreator}
          disabled={!instructorLedSchedulesAdd}
        />
        <Redirect path='*' to={simulatorTrainingRoutes.root} />
      </Switch>
    </Suspense>
  )
}

export default SchedulesRouting
